import { defineStore } from 'pinia';

export const useCurrentLangStore = defineStore('currentLang', {
    state: () => ({
        value: '',
    }),
    actions: {
        setCurrentLang(newLang: string) {
            this.value = newLang
            localStorage.setItem('currentLang', newLang)
        },
    },
    getters: {
        currentValue: (state) => state.value
    }
})
